import "./About.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import Footer from "@/reusable_sections/Footer";
import Darkhero from "./sections/Darkhero";
import Mission from "./sections/Mission";
import WhoWeServe from "./sections/WhoWeServe";
import WhatWeSupply from "./sections/WhatWeSupply";
import HowWeWork from "./sections/HowWeWork";
import BrandMeaning from "./sections/BrandMeaning";
import ExploreMore from "./sections/ExploreMore";
import Manufacturing from "./sections/Manufacturing";
export default function AboutPage() {
  return <div>
      <Header />
      <PageBreadcrumb page="About" />
      <Darkhero />
      <Mission />
      <WhoWeServe />
      <WhatWeSupply />
      <HowWeWork />
      <BrandMeaning />
      <ExploreMore />
      <Manufacturing />
      <Footer />
    </div>;
}